import React, {useEffect, useState} from "react";
import {Col, Row} from "react-bootstrap";
import {RequireAuth} from "Components/Security/RequireAuth";
import {DefaultContainer} from "Views/Shared/DefaultContainer";
import {useNavigate, useParams} from "react-router-dom";
import {MonthlyFeeModificationForm} from "Views/MonthlyFeeModification/MonthlyFeeModificationForm";
import {Notificator} from "Services/Notificator/Notificator";
import {ROUTE_PATHS} from "Config/Router/Routes";
import {useMutation, useQuery} from "react-query";
import {getMonthlyFeeModificationDetail} from "Api/Query/MonthlyFeeModificationQuery";
import {useAppDispatch} from "hooks";
import {appLoading} from "Store/loadingSlice";
import {updateMonthlyFeeModification} from "Api/Mutation/MonthlyFeeModificationMutation";

export const MonthlyFeeModificationEdit : React.FC = () => {

    const {id} = useParams()
    const navigate = useNavigate()
    const dispatch = useAppDispatch()

    const [entity, setEntity] = useState<any>({
        year: 0,
        monthNumber: 0,
        childId: "",
        amount: 0,
        description: ""
    })

    const update = useMutation({
        mutationKey: ['updateMonthlyFeeModificationMutation'],
        mutationFn: (body: any) => updateMonthlyFeeModification(body.id, body.data),
        onSuccess: () => {
            Notificator.success('La modificación de cuota mensual se ha editado correctamente')
            navigate(ROUTE_PATHS.ADMIN_MONTHLY_FEE_MODIFICATION_LIST)
        },
        onError: (response: any) => {
            const message = response.response?.data?._error?.message 
                ? ('Error: ' + response.response.data._error.message) 
                : 'Se ha producido un error al editar la modificación de cuota mensual.'
            Notificator.error(message)
        }
    })

    const onSave = (data: any) => {
        update.mutate({
            id: id,
            data: data
        })
    }

    const query = useQuery({
        enabled: false,
        queryKey: ['getMonthlyFeeModificationDetail', id],
        queryFn: () => getMonthlyFeeModificationDetail(id ?? '-1'),
        onSuccess: (response: any) => {
            const result = response.data._result
            setEntity({
                year: result.year,
                monthNumber: result.monthNumber,
                childId: result.childId,
                amount: result.amount,
                description: result.description ?? null
            })
        },
        onError: () => {
            Notificator.error('Se ha producido un error al cargar los datos.')
        }
    })

    useEffect(() => {
        query.refetch()
    }, []);

    useEffect(() => {
        dispatch(appLoading({value: query.isLoading, text: 'Cargando'}))
    }, [query.isLoading])

    useEffect(() => {
        dispatch(appLoading({value: update.isLoading, text: 'Guardando'}))
    }, [update.isLoading])

    useEffect(() => {
        dispatch(appLoading({value: query.isRefetching, text: 'Cargando'}))
    }, [query.isRefetching])

    return (
        <RequireAuth>
            <DefaultContainer>

                <Col>

                    <Row>
                        <Col>
                            <h1 className={"pb-4"}>Detalle de modificación de cuota mensual</h1>
                        </Col>

                    </Row>

                    <Row>
                        <MonthlyFeeModificationForm
                            onSave={onSave}
                            year={entity.year}
                            monthNumber={entity.monthNumber}
                            childId={entity.childId}
                            amount={entity.amount}
                            description={entity.description}
                        />
                    </Row>

                </Col>

            </DefaultContainer>
        </RequireAuth>
    )
}

